let check = JSON.parse(localStorage.getItem('checkPasswordMode')) || {checkPasswordMode: []}
// ACTIONS
const actions = {
  checkUserId({commit}, obj) {
    commit('checkUserId', obj)
  }
}
// MUTATIONS
const mutations = {
  checkUserId(_state, obj) {
    for (let idx = 0; idx < check.checkPasswordMode.length; idx++) {
      let elm = check.checkPasswordMode[idx]
      if (elm.userId === obj.userId) {
        elm.changePasswordFlag = obj.changePasswordFlag
        localStorage.setItem('checkPasswordMode', JSON.stringify(check))
        return
      }
    }
    check.checkPasswordMode.push(obj)
    localStorage.setItem('checkPasswordMode', JSON.stringify(check))
  }
}

const getters = {
  getChangePasswordFlag(_state) {
    const userStore = JSON.parse(localStorage.getItem('plusa-user'))
    if (!userStore) {
      return false
    }
    for (let idx = 0; idx < check.checkPasswordMode.length; idx++) {
      const elm = check.checkPasswordMode[idx]
      if (elm.userId === userStore.userId) {
        return elm.changePasswordFlag
      }
    }
    return false
  },
  getcheckPasswordMode(_state) {
    return check.checkPasswordMode
  }
}
export const checkPassword = {
  namespaced: true,
  actions,
  mutations,
  getters
}



// WEBPACK FOOTER //
// ./src/_store/check.module.js